import { action, observable } from 'mobx';
import UserManagementRepository from '@app/src/common/repository/UserManagementRepository';
import AuthStore from '@app/src/common/store/AuthStore';
import { getRoutes } from '@app/src/common/constants/routeUrls';
import routerStore from '@app/src/common/store/RouterStore';
import { DateTimeService } from '@app/src/services/DateTimeService';
import notificationService from '@app/src/services/notification-service/NotificationService';
import { DynamicForm } from '@app/src/common/components/dynamic-form';
import { signInFormConfig } from './SignInFormFields';

export default class AuthPageStore {
  @observable loading: boolean = false;
  form = new DynamicForm(signInFormConfig);

  @action
  signIn = async (email: string, password: string) => {
    this.loading = true;
    try {
      const response = await UserManagementRepository.signIn({
        email,
        password
      });
      const { access_token, refresh_token } = response.data;
      AuthStore.setToken(access_token, refresh_token);
      AuthStore.setSupportLogin(false);
      await AuthStore.initCurrentUser();
      const routes = await getRoutes();
      if (!routes) {
        return;
      }
      this.loading = false;
      routerStore.updateRoutes(routes);
      routerStore.navigate(routerStore.firstRoutePath);
    } catch (reject: any) {
      this.loading = false;
      if (reject.response) {
        const { Data } = reject.response.data;
        if (Data.LockExpires) {
          const lockExpires = new Date(Data.LockExpires).getTime();
          const remainingMinutes = DateTimeService.getMinutes(
            lockExpires - new Date().getTime()
          );
          notificationService.warningMessage(
            'notification.auth.error.try.again.min',
            { 0: remainingMinutes.toString() }
          );
          return;
        }
        notificationService.errorMessage('notification.auth.error');
        return;
      }
      notificationService.errorMessage('notification.network.error');
    }
  };
}
